export default {
    "info_text": "Erzähle Deinen Kunden von Deiner App Smarte Banner erkennen automatisch das genutzte Betriebssystem und empfehlen deinen Kunden die App-Installation, indem sie sie direkt zum entsprechenden App- oder Play Store weiterleiten."
}
